export default function (context, {value, field}) {
    let data = {};
    data[field] = value;
    context.commit('set', data);
}